import { render, staticRenderFns } from "./footer-bar.vue?vue&type=template&id=350c889c&"
import script from "./footer-bar.ts?vue&type=script&lang=ts&"
export * from "./footer-bar.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports